import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { MarkerAction, MarkerState } from './types/marker';

export const useMarkerStore = create<MarkerState & MarkerAction>()(
    devtools((set, get) => ({
        markerIds: {
            myLocation: undefined,
            myLocationPulse: undefined,
            poiList: undefined,
            selectedPoi: undefined,
        },

        setMarkerIds: (markerIds) => {
            set({ markerIds: { ...get().markerIds, ...markerIds } });
        },

        resetMarkerIds: () => {
            set({ markerIds: { myLocation: undefined, myLocationPulse: undefined, poiList: undefined, selectedPoi: undefined } });
        },
    }))
);
